import dayjs from "dayjs";

// `Input.DateTime` speaks local wall-clock time in this shape; the API wants
// ISO-8601 with the browser's offset, and answers `scheduled_to` the same way.
export const LOCAL_FORMAT = "YYYY-MM-DD HH:mm:ss";

// Publish at once, or at a chosen moment.
export const SCHEDULE_MODES = {
    NOW: "now",
    SCHEDULED: "scheduled",
};

// Every new post starts here: the schedule choice is never remembered.
export const SCHEDULE_NOW = { mode: SCHEDULE_MODES.NOW, value: "" };

export function localToIso(local) {
    if (!local) return null;
    const date = dayjs(local);
    return date.isValid() ? date.format("YYYY-MM-DDTHH:mm:ssZ") : null;
}

export function isoToLocal(iso) {
    if (!iso) return "";
    const date = dayjs(iso);
    return date.isValid() ? date.format(LOCAL_FORMAT) : "";
}

export function isInFuture(local) {
    if (!local) return false;
    const date = dayjs(local);
    return date.isValid() && date.isAfter(dayjs());
}

// The app's own date formatter, fed an ISO string so every browser parses it.
export function localToDisplay(local) {
    const date = dayjs(local);
    return date.isValid() ? window.helpers.pretty.date(date.toISOString()) : "";
}

function tomorrowAt(hour) {
    return dayjs().add(1, "day").hour(hour).minute(0).second(0);
}

function nextMondayAt(hour) {
    const today = dayjs().day(); // 0 = Sunday … 6 = Saturday
    const daysAhead = ((8 - today) % 7) || 7;
    return dayjs().add(daysAhead, "day").hour(hour).minute(0).second(0);
}

// Chips under the date inputs. Recomputed at call time (relative to "now")
// and labelled in the active language.
export function getScheduleSuggestions(t) {
    return [
        { key: "tomorrowMorning", value: tomorrowAt(9).format(LOCAL_FORMAT), label: t("publishPost.schedule.suggestions.tomorrowMorning") },
        { key: "tomorrowEvening", value: tomorrowAt(19).format(LOCAL_FORMAT), label: t("publishPost.schedule.suggestions.tomorrowEvening") },
        { key: "nextMonday", value: nextMondayAt(9).format(LOCAL_FORMAT), label: t("publishPost.schedule.suggestions.nextMonday") },
        { key: "inOneWeek", value: dayjs().add(7, "day").second(0).format(LOCAL_FORMAT), label: t("publishPost.schedule.suggestions.inOneWeek") },
    ];
}

// Switching to "schedule" without a moment yet starts at the first chip.
export function defaultScheduled(t) {
    return { mode: SCHEDULE_MODES.SCHEDULED, value: getScheduleSuggestions(t)[0].value };
}

export function scheduledAt(value) {
    return { mode: SCHEDULE_MODES.SCHEDULED, value: value || "" };
}
